import { reactive, ref } from 'vue';
import "ant-design-vue/es/modal/style/css";
import _Modal from "ant-design-vue/es/modal";
import "ant-design-vue/es/message/style/css";
import _message from "ant-design-vue/es/message";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
import "core-js/modules/es.array.push.js";
import { Post } from '@/api/Api';
import DMPrice from './SubmitOrders.vue';
import DResult from '@/components/DResult/DResult.vue';
const __default__ = {
  name: 'List',
  components: {
    DMPrice,
    DResult
  },
  data() {
    tableHeight: '';
  },
  setup(props, context) {
    const DMConfig = reactive({
      AppName: '',
      Width: 0,
      Height: 0,
      Columns: [{
        title: "单据编号",
        dataIndex: "billNo",
        customRender: record => {
          return _createVNode("a", {
            "onclick": () => {
              DMPriceref.value.Open(record.record.fId, 0, 0);
            }
          }, [_createTextVNode(" "), record.record.billNo, _createTextVNode(" ")]);
        }
      }, {
        title: "客户代码",
        dataIndex: "fCustNumber"
        /* customRender:(record) => {
        	return <a onclick ={() => {DMPriceref.value.Open(record.record.fId,800,0)}}> {record.record.fCustNumber} </a>
        } */
      }, {
        title: "客户名称",
        dataIndex: "fCustName"
      }, {
        title: "创建日期",
        dataIndex: "fCreatedDate",
        width: 160
      }, {
        title: "状态",
        dataIndex: "fState",
        customRender: record => {
          return GetTableStateCol(record.record.fState);
        },
        width: 80,
        align: 'center'
      }, {
        title: "K3订单号",
        dataIndex: "fK3BillNo",
        width: 160
      }, {
        title: "邮件",
        dataIndex: "fIsSend",
        customRender: record => {
          return GetTableIsSendCol(record.record.fIsSend);
        },
        width: 80,
        align: 'center'
      }, {
        title: "审核日期",
        dataIndex: "fCheckDate",
        width: 160
      }],
      QueryParam: {},
      DataSource: [],
      selectedRowKeys: [],
      selectedRows: [],
      loading: false,
      RowKey: 'fId',
      ForkHeight: 10,
      //表格离低高度
      IsSelect: true,
      //序时簿是否支持选择
      IsMultipleSelect: false,
      //序时簿是否多选
      QueryWhere: {
        total: 0,
        current: 1,
        pageSize: 100,
        showTotal: total => {
          return `共${total}条`;
        }
      }
    });
    const OnTableChange = (pag, filters, sorter) => {
      console.log(pag);
      DMConfig.QueryWhere.current = pag.current;
      DMConfig.QueryWhere.pageSize = pag.pageSize;
      LoadData(filters, sorter);
    };
    const onSelectChange = (selectedRowKeys, selectedRows) => {
      //console.log(selectedRowKeys)
      //console.log(selectedRows)
      DMConfig.selectedRowKeys = selectedRowKeys;
      DMConfig.selectedRows = selectedRows;
    };
    const Refresh = (bool = false) => {
      bool && (DMConfig.QueryWhere = Object.assign(DMConfig.QueryWhere, {
        current: 1
      }));
      LoadData();
    };
    const LoadData = (filters, sorter) => {
      DMConfig.loading = true;

      //DMConfig.QueryParam.SearchValue = "";
      DMConfig.QueryParam.PageNo = DMConfig.QueryWhere.current;
      DMConfig.QueryParam.PageSize = DMConfig.QueryWhere.pageSize;
      Post("dm/SubmitOrdersListAll", DMConfig.QueryParam).then(res => {
        DMConfig.DataSource = res.data.rows;
        DMConfig.QueryWhere.total = res.data.total;
        DMConfig.QueryWhere.current = res.data.current;
        DMConfig.QueryWhere.pageSize = res.data.pageSize;
        DMConfig.loading = false;
      });
    };
    const GetTableYesNoCol = record => {
      if (record.value) return _createVNode(_resolveComponent("a-tag"), {
        "color": 'rgb(5, 160, 69)'
      }, {
        default: () => [_createTextVNode(" \u662F ")]
      });else return _createVNode(_resolveComponent("a-tag"), {
        "color": 'rgb(255, 0, 51)'
      }, {
        default: () => [_createTextVNode(" \u5426 ")]
      });
    };
    const GetTableStateCol = record => {
      if (record == 2)
        //未提交
        return _createVNode(_resolveComponent("a-tag"), {
          "color": 'rgb(160, 160, 160)'
        }, {
          default: () => [_createTextVNode(" \u672A\u63D0\u4EA4 ")]
        });else if (record == 0)
        //未确认
        return _createVNode(_resolveComponent("a-tag"), {
          "color": 'rgb(255, 170, 0)'
        }, {
          default: () => [_createTextVNode(" \u5F85\u5BA1\u6838 ")]
        });else if (record == 1)
        //已确认
        return _createVNode(_resolveComponent("a-tag"), {
          "color": 'rgb(5, 160, 69)'
        }, {
          default: () => [_createTextVNode(" \u5DF2\u5BA1\u6838 ")]
        });else if (record == 3) return _createVNode(_resolveComponent("a-tag"), {
        "color": 'rgb(255, 0, 51)'
      }, {
        default: () => [_createTextVNode(" \u53CD\u5BA1\u6838 ")]
      });else if (record == 4) return _createVNode(_resolveComponent("a-tag"), {
        "color": 'rgb(255, 0, 51)'
      }, {
        default: () => [_createTextVNode(" \u9000\u56DE ")]
      });
    };
    const GetTableIsSendCol = record => {
      if (record == 0)
        //未提交
        return _createVNode(_resolveComponent("a-tag"), {
          "color": 'rgb(160, 160, 160)'
        }, {
          default: () => [_createTextVNode(" - ")]
        });else if (record == 1)
        //未确认
        return _createVNode(_resolveComponent("a-tag"), {
          "color": 'rgb(255, 170, 0)'
        }, {
          default: () => [_createTextVNode(" \u5185\u90E8 ")]
        });else if (record == 2)
        //已确认
        return _createVNode(_resolveComponent("a-tag"), {
          "color": 'rgb(5, 160, 69)'
        }, {
          default: () => [_createTextVNode(" \u5916\u90E8 ")]
        });
    };
    const OnQuery = () => {
      DMConfig.selectedRowKeys = [];
      DMConfig.selectedRows = [];
      Refresh(true);
    };
    const OnCreate = () => {
      DMPriceref.value.Open(0, 800, 0);
    };
    const OnDelete = () => {
      let _this = this;
      let Ids = [];
      DMConfig.selectedRows.forEach(m => {
        Ids.push(Number(m.fId));
      });
      Ids = Array.from(new Set(Ids));
      if (Ids.length == 0) {
        _message.error('请选择需要删除的行!');
      } else {
        _Modal.confirm({
          title: '提示',
          centered: true,
          content: '确认要删除选中的数据吗?',
          onOk: () => {
            DMConfig.loading = true;
            Post("DM/DeleteSubmitOrders", Ids).then(res => {
              DMConfig.loading = false;
              DResultRef.value.Open(res.data);
              OnQuery();
            }).catch(err => {
              _message.error('删除错误：' + err.errors);
            });
          }
        });
      }
    };
    const DateFormat = text => {
      text = text.substring(0, 10);
      //var reg=/(\d{5})(\d{2})(\d{2})/;
      //text =text.replace(reg,'$1-$2-$3');
      return text;
    };
    const OnSend = () => {
      let _this = this;
      let Ids = [];
      DMConfig.selectedRows.forEach(m => {
        Ids.push(Number(m.fId));
      });
      Ids = Array.from(new Set(Ids));
      if (Ids.length == 0) {
        _message.error('请选择需要发送邮件的行!');
      } else {
        _Modal.confirm({
          title: '提示',
          centered: true,
          content: '确认要发送邮件选中的数据吗?',
          onOk: () => {
            DMConfig.loading = true;
            Post("DM/SendSubmitOrders", Ids).then(res => {
              DMConfig.loading = false;
              DResultRef.value.Open(res.data);
              OnQuery();
            }).catch(err => {
              _message.error('发送错误：' + err.errors);
            });
          }
        });
      }
    };
    const OnAudit = () => {
      let _this = this;
      let Ids = [];
      DMConfig.selectedRows.forEach(m => {
        Ids.push(Number(m.fId));
      });
      Ids = Array.from(new Set(Ids));
      if (Ids.length == 0) {
        _message.error('请选择需要审核的行!');
      } else {
        _Modal.confirm({
          title: '提示',
          centered: true,
          content: '确认要审核选中的数据吗?',
          onOk: () => {
            DMConfig.loading = true;
            Post("DM/Audit", Ids).then(res => {
              DMConfig.loading = false;
              DResultRef.value.Open(res.data);
              OnQuery();
            }).catch(err => {
              _message.error('审核错误：' + err.errors);
            });
          }
        });
      }
    };
    const OnUnAudit = () => {
      let _this = this;
      let Ids = [];
      DMConfig.selectedRows.forEach(m => {
        Ids.push(Number(m.fId));
      });
      Ids = Array.from(new Set(Ids));
      if (Ids.length == 0) {
        _message.error('请选择需要反审核的行!');
      } else {
        _Modal.confirm({
          title: '提示',
          centered: true,
          content: '确认要反审核选中的数据吗?',
          onOk: () => {
            DMConfig.loading = true;
            Post("DM/UnAudit", Ids).then(res => {
              DMConfig.loading = false;
              DResultRef.value.Open(res.data);
              OnQuery();
            }).catch(err => {
              _message.error('反审核错误：' + err.errors);
            });
          }
        });
      }
    };
    const OnReturn = () => {
      let _this = this;
      let Ids = [];
      DMConfig.selectedRows.forEach(m => {
        Ids.push(Number(m.fId));
      });
      Ids = Array.from(new Set(Ids));
      if (Ids.length == 0) {
        _message.error('请选择需要退回的行!');
      } else {
        _Modal.confirm({
          title: '提示',
          centered: true,
          content: '确认要退回选中的数据吗?',
          onOk: () => {
            DMConfig.loading = true;
            Post("DM/OnReturn", Ids).then(res => {
              DMConfig.loading = false;
              DResultRef.value.Open(res.data);
              OnQuery();
            }).catch(err => {
              _message.error('退回错误：' + err.errors);
            });
          }
        });
      }
    };
    const DMPriceref = ref();
    const DResultRef = ref();
    return {
      DMConfig,
      OnQuery,
      OnTableChange,
      onSelectChange,
      LoadData,
      GetTableYesNoCol,
      GetTableStateCol,
      GetTableIsSendCol,
      OnCreate,
      OnDelete,
      Refresh,
      OnSend,
      DMPriceref,
      DResultRef,
      OnAudit,
      OnUnAudit,
      OnReturn
    };
  },
  created() {},
  mounted() {
    let _this = this;
    _this.resetTableHeight();
    window.onresize = function () {
      _this.resetTableHeight();
    };
    this.LoadData();
  },
  methods: {
    resetTableHeight() {
      let _this = this;
      var id;
      let tHeader = null;
      if (id) {
        tHeader = document.getElementById(id) ? document.getElementById(id).getElementsByClassName("ant-table-thead")[0] : null;
      } else {
        tHeader = document.getElementsByClassName("ant-table-thead")[0];
      }
      //表格内容距离顶部的距离
      let tHeaderBottom = 0;
      if (tHeader) {
        tHeaderBottom = tHeader.getBoundingClientRect().bottom;
      }
      console.log(tHeaderBottom);

      //页面高度
      let clientHeight = document.documentElement.clientHeight;
      _this.tableHeight = clientHeight - tHeaderBottom - 112 - _this.DMConfig.ForkHeight + 'px';
      /*
      //搜索高度
      let searchBarHeight=0
      //let searchBarHeight = document.getElementById("advanced_search").clientHeight;
      //表格工具栏高度
      let tabletoolHeight = document.getElementById("table_tool").clientHeight;
      _this.tableHeight = (clientHeight - 120 -40 - (searchBarHeight + 16) - (tabletoolHeight + 32) - _this
      	.DMConfig.ForkHeight) + 'px'
      	*/
    }
  },

  watch: {
    // expand(val) {
    // 	let _this=this
    // 	setTimeout(function() {
    // 			_this.resetTableHeight();
    // 	}, 10)
    // }
  }
};
import { useCssVars as _useCssVars } from 'vue';
const __injectCSSVars__ = () => {
  _useCssVars(_ctx => ({
    "4a679103": _ctx.tableHeight
  }));
};
const __setup__ = __default__.setup;
__default__.setup = __setup__ ? (props, ctx) => {
  __injectCSSVars__();
  return __setup__(props, ctx);
} : __injectCSSVars__;
export default __default__;